<template>
  <el-tabs v-model="activeName">
    <el-tab-pane :label="$t('statisticsGoogle.overview')" name="overview">
     <div class="container-cards">
       <div class="cards-wrapper">
         <div class="box-card-google">
           <h2>{{ $t('statisticsGoogle.titleGoogle')}}</h2>
           <h3>{{$t('statisticsMeta.discover')}}</h3>
           <StatisticItem
               :attribute="$t('statisticsMeta.likedPage')"
               filename="desktop.png"
               :label="$t('statisticsGoogle.searchByDesktop')"
               :value="getTotalMetricByMetric('BUSINESS_IMPRESSIONS_DESKTOP_SEARCH')"
           />
           <StatisticItem
               :attribute="$t('statisticsMeta.likedPage')"
               filename="desktop.png"
               :label="$t('statisticsGoogle.searchGoogleMapsByDesktop')"
               :value="getTotalMetricByMetric('BUSINESS_IMPRESSIONS_DESKTOP_MAPS')"
           />
           <StatisticItem
               :attribute="$t('statisticsMeta.likedPage')"
               filename="mobile.png"
               :label="$t('statisticsGoogle.searchByMobile')"
               :value="getTotalMetricByMetric('BUSINESS_IMPRESSIONS_MOBILE_SEARCH')"
           />
           <StatisticItem
               :attribute="$t('statisticsMeta.likedPage')"
               filename="mobile.png"
               :label="$t('statisticsGoogle.searchGoogleMapsByMobile')"
               :value="getTotalMetricByMetric('BUSINESS_IMPRESSIONS_MOBILE_MAPS')"
           />
           <h3>
             {{ $t('statisticsGoogle.sheetEtablishmentEngagement')}}
           </h3>
           <div class="line-stats">
             <div>
               <img alt="click picture" :src="require(`@/assets/iconsStats/click.png`)" width="18px" class="icon-engagement"/>
               <span class="stat-number">{{ getTotalMetricByMetric('BUSINESS_DIRECTION_REQUESTS')}}</span><span class="content-engagement">{{ $t('statisticsGoogle.numberCallItinerary')}}</span>
             </div>
             <div>
               <img alt="click picture" :src="require(`@/assets/iconsStats/click.png`)" width="18px" class="icon-engagement"/>
               <span class="stat-number">{{ getTotalMetricByMetric('CALL_CLICKS')}}</span><span class="content-engagement">{{ $t('statisticsGoogle.numberClickedButtonCall')}}</span>
             </div>
             <div>
               <img alt="click picture" :src="require(`@/assets/iconsStats/click.png`)" width="18px" class="icon-engagement"/>
               <span class="stat-number">{{ getTotalMetricByMetric('WEBSITE_CLICKS')}}</span><span class="content-engagement">{{ $t('statisticsGoogle.numberClickedWebSite')}}</span>
             </div>
           </div>
         </div>
         <div class="cards-wrapper">
           <div class="box-card-google">
             <h2>{{ $t('statisticsGoogle.titleGoogleGraph')}}</h2>
             <LineChart :chartData="getLineChartDataImpressionsGoogle" :chartOptions="getLineChartOptionsGoogle" />
           </div>
         </div>
       </div>
     </div>
    </el-tab-pane>
  </el-tabs>
</template>
<script>
import { TabPane, Tabs } from 'element-ui'
import StatisticItem from '@/pages/statistics/statisticsMeta/components/StatisticItem.vue'
import LineChart from '@/chart/LineChart.vue'
import { mapActions, mapGetters } from 'vuex'
import { $t } from '@/i18n'
import BoxInfos from '@/components/ui/BoxInfos.vue'

export default {
  name: 'GoogleStatistics',
  components: {
    LineChart,
    StatisticItem,
    ElTabs: Tabs,
    ElTabPane: TabPane
  },
  data () {
    return {
      activeName: 'overview',
      showBoxInfos: true,
    }
  },
  computed: {
    ...mapGetters('statisticsGoogle', [
      'getLoadingGoogle',
      'getTotalMetricByMetric',
      'getDatedValuesByMetric'
    ]),
    getLineChartOptionsGoogle () {
      return {
        responsive: true,
        lineTension: 1,
        scales: {
          y: {
            beginAtZero: true,
            padding: 25
          }
        }
      }
    },
    getLineChartDataImpressionsGoogle: function () {
      const impressionsTotal = this.getDatedValuesByMetric('IMPRESSIONS_TOTAL')
      if (impressionsTotal.length > 0) {
        const allDates = impressionsTotal.map((item) => item.formattedDate)
        const valuesStats = impressionsTotal.map((item) => item.value)
        return {
          labels: allDates,
          datasets: [
            {
              label: $t('statisticsGoogle.numberSearchByDay'),
              data: valuesStats,
              borderColor: '#00a4bd',
              borderWidth: 1
            }
          ]
        }
      } else {
        return {
          labels: [],
          datasets: []
        }
      }
    }
  },
  methods: {
    ...mapActions('statisticsGoogle', ['loadStatisticsGoogle']),
    closeBoxInfos (args) {
      if (args === 'close') {
        this.showBoxInfos = false
      }
    }
  },
  mounted () {
    this.activeName = 'overview'
    this.loadStatisticsGoogle()
  }
}
</script>

<style scoped>
h3, .stat-number {
  color: #00a4bd;
  font-weight: 600;
  text-transform: Capitalize;
  font-size: 20px;
  margin-top: 20px;
}
.container-cards {
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin-top: 15px;
}
.cards-wrapper {
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;
}
.box-card-google {
  margin: 5px;
  width: 45%;
  min-width: 430px;
  min-height: 400px;
  padding: 10px;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
}
.box-card-google-single {
  margin: 15px;
  width: 95%;
  min-height: 400px;
  padding: 10px;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
}
strong {
  font-weight: bolder;
}
.icon-engagement {
  margin-right: 10px;
}
.content-engagement {
  font-family: "Dosis", Helvetica, Arial, sans-serif;
  margin-left: 5px;
}
.line-stats{
  margin-bottom: 10px;
  font-family: "Dosis", Helvetica, Arial, sans-serif;
  font-size: 15px;
}
</style>
